import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import { Grid } from 'semantic-ui-react'

import Loading from '../../components/common/loading'
import Sponsor from './components/Sponsor'
import Trending from './components/Trending'
import Recommended from './components/RecommendItem'
import RecentList from './components/RecentList'

import SponsorActions from '../../reducers/sponsorReducer'
import PopularActions from '../../reducers/popularReducer'
import RestaurantActions from '../../reducers/restaurantReducer'
import RecentListActions from '../../reducers/recentListReducer'

class AdvertisementContainer extends Component {
  componentDidMount() {
    const { restaurantLoaded, sponsorsLoaded, popularListLoaded, recentListsLoaded } = this.props
    const { getSponsors, getRestaurants, getPopularList, getRecentLists } = this.props

    if (!restaurantLoaded) {
      getRestaurants()
    }

    if (!sponsorsLoaded) {
      getSponsors()
    }

    if (!popularListLoaded) {
      getPopularList()
    }

    if (!recentListsLoaded) {
      getRecentLists()
    }
  }

  render() {
    const { restaurantLoading, sponsorsLoading, popularListLoading, recentListsLoading } = this.props

    const loading = restaurantLoading || sponsorsLoading || popularListLoading || recentListsLoading

    return (
      <div>
        <Loading active={loading} />
        <Grid>
          <Grid.Row>
            <Grid.Column width="16">
              <Sponsor {...this.props} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width="16">
              <Trending {...this.props} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width="16">
              <RecentList {...this.props} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width="16">
              <Recommended {...this.props} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ sponsors, popular, restaurants, recentLists }) => ({
  sponsorsLoaded: sponsors.loaded,
  sponsorsLoading: sponsors.loading,
  sponsors: _.reverse(
    _.map(Object.keys(sponsors.sponsors), sponsorKey => ({
      ...sponsors.sponsors[sponsorKey],
      sponsorKey,
    }))
  ),
  popularListLoaded: popular.listLoaded,
  popularListLoading: popular.listLoading,
  popularList: popular.popularList,
  restaurants: restaurants.data,
  restaurantLoading: restaurants.loading,
  restaurantLoaded: restaurants.loaded,

  recentLists: recentLists.data,
  recentListsLoaded: recentLists.loaded,
  recentListsLoading: recentLists.loading
})

const mapDispatch = {
  getRecentLists: RecentListActions.getRecentLists,
  getSponsors: SponsorActions.getSponsors,
  getPopularList: PopularActions.getPopularList,
  getRestaurants: RestaurantActions.fetchRestaurantsRequest,
}

export default connect(
  mapState,
  mapDispatch
)(withRouter(AdvertisementContainer))



// WEBPACK FOOTER //
// ./src/containers/advertisement/index.js